import React, { useState, useEffect } from 'react'
import { RouteComponentProps } from 'react-router'
import { Dispatch } from 'redux'
import { Formik } from 'formik'
import { IServerConfig } from '../../types/config'
import { IDataChartData, ICreateDataChartAction } from '../../types/datachart'
import { ICreatePackFromDataStreamURI } from '../../types/pack'
import { IGroupParam } from '../../types/router'
import { transformToHttps } from '../../services/http'
import { DataChartModal } from '../../components'
import { DataChartUrlForm } from './DataChartUrlForm'

export interface ICreateDataChartForm {
  onSubmitAction: (
    groupId: string,
    title: string,
    uri: string
  ) => ICreateDataChartAction | ICreatePackFromDataStreamURI
  disabled?: boolean
}

export interface ICreateDataChartFormConnectedProps {
  datachart: IDataChartData
  serverConfig: IServerConfig
  dispatch: Dispatch
}

export const CreateDataChartForm = ({
  match: {
    params: { groupId },
  },
  serverConfig,
  datachart,
  onSubmitAction,
  disabled,
  dispatch,
}: ICreateDataChartForm &
  ICreateDataChartFormConnectedProps &
  RouteComponentProps<IGroupParam>) => {
  const [openModal, setOpenModal] = useState(false)
  useEffect(() => setOpenModal(false), [])
  return (
    <>
      <Formik
        validateOnChange
        initialValues={{ dataStreamURI: datachart.dataStreamURI }}
        onSubmit={(values): void => {
          setOpenModal(true)
        }}
        render={({ isValid, values }) => (
          <>
            <DataChartUrlForm
              isValid={isValid}
              serverConfig={serverConfig}
              disabled={disabled}
            />
            <DataChartModal
              open={openModal}
              title="Upload DataStream"
              handleClose={(): void => setOpenModal(false)}
              handleSubmit={(title: string): void => {
                dispatch(
                  onSubmitAction(
                    groupId,
                    title,
                    transformToHttps(values.dataStreamURI)
                  )
                )
              }}
              dataStreamURI={transformToHttps(values.dataStreamURI)}
              isLoading={datachart.isLoading}
            />
          </>
        )}
      />
    </>
  )
}
